import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class RelatorioServico extends Servico {
  constructor() {
    super('relatorio')
  }

  relatorioLevantamentoMarketing(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/marketing`, { params: filtro })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioLevantamentoMarketingDownload(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/marketing/download`, {
        params: filtro,
        responseType: 'arraybuffer',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioHorariosAbertosVsMarcados(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/agendamentos_marcados`, {
        params: filtro,
        responseType: 'arraybuffer',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioMediaEvaPorEspecialidade(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/eva`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioMediaEvaPorEspecialidadeDownload(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/eva/download`, {
        params: filtro,
        responseType: 'arraybuffer',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioPagamentoGuia(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/relatorio_pagamento_por_faturamento`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
  relatorioPagamentoIndicacaoGuia(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/relatorio_pagamento_por_indicacao`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  relatorioGuiasNaoFaturadas(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/guias_nao_faturadas`, { params: filtro })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err, true)
      })
  }

  relatorioGuiasNaoFaturadosDownload(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/relatorios/guias_nao_faturadas/download`, {
        params: filtro,
        responseType: 'arraybuffer',
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err, true)
      })
  }
}

export default RelatorioServico
